import 'prism-themes/themes/prism-material-dark.css'
import 'rc-switch/assets/index.css'
import 'styles/global.css'